import { render, staticRenderFns } from "./consultLabel.vue?vue&type=template&id=55b8fcc0"
import script from "./consultLabel.vue?vue&type=script&lang=js"
export * from "./consultLabel.vue?vue&type=script&lang=js"
import style0 from "./consultLabel.vue?vue&type=style&index=0&id=55b8fcc0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports